export default __webpack_public_path__ + "static/media/logout.ab831324.svg";